export default "__VITE_ASSET__BWUMtNbu__"